import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api, { apiErr } from "../lib/api";
import { Settings, Save } from "lucide-react";
import { toast } from "sonner";

const input = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100";

export default function Configuracion() {
  const { setMobileOpen } = useOutletContext();
  const [cfg, setCfg] = useState({ comision_pct: 0.1, nombre_empresa: "Pya'elino Courier", whatsapp_soporte: "", nota: "" });
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => { api.get("/config").then(({ data }) => setCfg((c) => ({ ...c, ...data }))).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.put("/config", { comision_pct: Number(cfg.comision_pct), nombre_empresa: cfg.nombre_empresa, whatsapp_soporte: cfg.whatsapp_soporte, nota: cfg.nota }); toast.success("Configuración guardada"); }
    catch (e2) { toast.error(apiErr(e2)); }
    finally { setLoading(false); }
  };

  return (
    <>
      <Header title="Configuración" subtitle="Parámetros generales del sistema" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 max-w-2xl">
        <form onSubmit={save} className="bg-white rounded-xl border border-[#E2E8F0] p-6 shadow-sm space-y-4">
          <div className="flex items-center gap-3 pb-4 border-b border-slate-100"><div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center"><Settings className="h-5 w-5 text-[#3B82F6]" /></div><div className="font-bold text-[#0A1F44] font-display">Parámetros</div></div>
          <div><label className="text-xs font-semibold text-[#64748B]">Nombre de la empresa</label><input className={input} value={cfg.nombre_empresa} onChange={(e) => setCfg({ ...cfg, nombre_empresa: e.target.value })} data-testid="cfg-nombre-input" /></div>
          <div><label className="text-xs font-semibold text-[#64748B]">Comisión sobre flete (ej. 0.10 = 10%)</label><input type="number" step="0.01" min="0" max="1" className={input} value={cfg.comision_pct} onChange={(e) => setCfg({ ...cfg, comision_pct: e.target.value })} data-testid="cfg-comision-input" /></div>
          <div><label className="text-xs font-semibold text-[#64748B]">WhatsApp de soporte</label><input className={input} placeholder="0981..." value={cfg.whatsapp_soporte || ""} onChange={(e) => setCfg({ ...cfg, whatsapp_soporte: e.target.value })} /></div>
          <div><label className="text-xs font-semibold text-[#64748B]">Nota interna</label><textarea className={input} rows={3} value={cfg.nota || ""} onChange={(e) => setCfg({ ...cfg, nota: e.target.value })} /></div>
          <button disabled={loading} data-testid="cfg-save-btn" className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#0A1F44] hover:bg-[#132D5C] text-white font-semibold py-2.5 text-sm disabled:opacity-60"><Save className="h-4 w-4" /> {loading ? "Guardando..." : "Guardar"}</button>
        </form>
      </main>
    </>
  );
}
